import { QueryKey, UseQueryResult, useQuery } from 'react-query';
import moment from 'moment';

import { GetSalesAndLabor } from '@pimm/services/lib/sms-workforce/services';

type GetSalesAndLaborParams = {
  siteId?: string;
  date?: Date;
};

export const useGetSalesAndLabor = (
  query?: GetSalesAndLaborParams,
  queryKey?: string,
): UseQueryResult<Awaited<ReturnType<typeof GetSalesAndLabor>>> => {
  const saleAmounts = useQuery({
    enabled: !!query?.siteId && !!query?.date,
    queryKey: [queryKey ?? 'GetSalesAndLabor', query] as [QueryKey, GetSalesAndLaborParams],
    queryFn: async ({ queryKey: [key, params] }) => {
      const date = moment(params.date);
      const result = await GetSalesAndLabor({ siteId: params.siteId, date: date.format().slice(0, 19) });
      return result;
    },
    staleTime: 8 * 60 * 1000, // 8 minutes
    refetchOnWindowFocus: true,
    refetchIntervalInBackground: false,
    refetchInterval: () => {
      // Based on Rosnet refresh analysis — data reliably available by :15 and :45
      const now = new Date();
      const minutes = now.getMinutes();
      let targetMinute: number;

      if (minutes < 15) {
        targetMinute = 15;
      } else if (minutes < 45) {
        targetMinute = 45;
      } else {
        targetMinute = 15;
        now.setHours(now.getHours() + 1);
      }
      const next = new Date(now);
      next.setMinutes(targetMinute, 0, 0);

      return next.getTime() - Date.now();
    },
  });
  return saleAmounts;
};
